import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InspecaoRepository } from '@app/data/inspecoes/inspecao.repository';
import { InspecaoModel } from '@app/data/inspecoes/models';
import { InspecaoStatusMap } from '@modules/inspecoes/controllers';
import { dateHoursFormat } from '@shared/formatters';

@Component({
  selector: 'app-detalhes-inspecao',
  templateUrl: './detalhes-inspecao.component.html',
  styleUrls: ['./detalhes-inspecao.component.scss'],
})
export class DetalhesInspecaoComponent implements OnInit {
  public inspecao: InspecaoModel | null = null;
  public loading: boolean = true;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { codigoInspecao: string; inspecao?: InspecaoModel },
    private dialogRef: MatDialogRef<DetalhesInspecaoComponent>,
    private inspecaoRepository: InspecaoRepository,
  ) {
    if (data?.inspecao) {
      this.inspecao = data.inspecao;
    }
  }

  ngOnInit(): void {
    if (this.data?.codigoInspecao) {
      this.carregarDetalhes(this.data.codigoInspecao);
    } else {
      this.loading = false;
    }
  }

  private carregarDetalhes(codigoInspecao: string): void {
    this.loading = true;
    this.inspecaoRepository
      .getByIdRequest<any>(codigoInspecao)
      .subscribe({
        next: (response) => {
          const result = response?.data || response;
          if (result) {
            this.inspecao = {
              ...(this.inspecao || {}),
              ...result,
            };
          }
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
        },
      });
  }

  public formatDate(dateString?: string): string {
    if (!dateString) return '-';
    return dateHoursFormat(dateString) || dateString;
  }

  public formatNivelCombustivel(nivel?: number): string {
    if (nivel === undefined || nivel === null) return '-';
    switch (nivel) {
      case 0:
        return 'Vazio (0/4)';
      case 1:
        return '1/4';
      case 2:
        return '1/2 (Meio Tanque)';
      case 3:
        return '3/4';
      case 4:
        return 'Cheio (4/4)';
      default:
        return `${nivel}`;
    }
  }

  public close(): void {
    this.dialogRef.close();
  }
}
